import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Livrare',
  [ORDER_METHODS.pickup]: 'Ridicare',
  [ORDER_METHODS.on_site]: 'Comenzi la masă',
};
